var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 26,
    viewBox: "0 0 67 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4571 23.4343L31.0125 25.6294H42.6516L43.0226 23.4343H31.4571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7482 23.4343L50.2998 25.6294H61.7719L62.219 23.4343H50.7482Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16207 23.4343L0 25.6294H11.7816C12.1588 24.8985 12.5371 24.1652 12.9142 23.4343H1.16207Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7166 23.4343V25.6294H26.7378C26.7145 24.8985 26.6899 24.1652 26.6666 23.4343H15.7166Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1352 20.0869L31.7629 21.9271H43.2768L43.5876 20.0869H32.1352Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4311 20.0869L51.0552 21.9271H62.5273L62.9019 20.0869H51.4311Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93725 20.0869L1.96313 21.9271H13.6932C14.0101 21.3141 14.3258 20.6999 14.6427 20.0869H2.93725Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7166 20.0869V21.9271H26.6162C26.5965 21.3141 26.5757 20.6999 26.556 20.0869H15.7166Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71001 16.7395L3.72852 18.592H26.5068C26.4872 17.9753 26.4663 17.3562 26.4467 16.7395H4.71124H4.71001Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8144 16.7395L32.4385 18.592H43.8418L44.155 16.7395H32.8144Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1142 16.7395L51.7371 18.592H63.2079L63.5863 16.7395H52.1142Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4847 13.3909L5.49707 15.2557H26.3972C26.3763 14.6341 26.3566 14.0113 26.3358 13.3909H6.4847Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4941 13.3909L33.1157 15.2569H44.4048L44.7205 13.3909H33.4941Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7971 13.3909L52.4163 15.2569H63.8871L64.2679 13.3909H52.7971Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25746 10.0434L7.26245 11.9216H26.2856C26.2647 11.2963 26.245 10.6699 26.2241 10.0434H8.25746Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4802 10.0434L53.0969 11.9204H64.5678L64.951 10.0434H53.4802Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6561 10.0434C47.45 10.0532 43.244 10.0581 39.0404 10.0569C35.6094 10.0569 32.1809 10.052 28.75 10.0434C30.5619 10.3247 32.3726 10.6072 34.1833 10.8897C34.1034 11.2337 34.0223 11.5776 33.9425 11.9216H45.1333C45.2303 11.5703 45.3273 11.2202 45.4244 10.8689C47.5016 10.5949 49.5813 10.3185 51.6586 10.0446H51.6573L51.6561 10.0434Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0326 6.69476L9.03149 8.58528H26.1788C26.1579 7.95511 26.1371 7.32494 26.1174 6.69476H10.0339H10.0326Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391 6.69476L29.0273 8.58528H51.9482L52.3278 6.69476H29.3897H29.391Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1631 6.69476L53.7773 8.58528H65.2494L65.6352 6.69476H54.1631Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8064 3.34863L10.7979 5.25143H26.0682C26.0473 4.61758 26.0264 3.98249 26.0055 3.34863H11.8064Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0335 3.34863L29.6687 5.25143H52.6202L53.0023 3.34863H30.0335Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8459 3.34863L54.4578 5.25143H65.9286L66.3168 3.34863H54.8459Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5803 0L12.5657 1.91509H25.959L25.8963 0H13.5816H13.5803Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6747 0L30.3074 1.91509H53.2884L53.6741 0H30.6747Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5291 0L55.1384 1.91509H66.6093L66.9999 0H55.5291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAti);
export default __webpack_public_path__ + "static/media/logo-ati.639fbbf5683694dd32709dbf8cd3040f.svg";
export { ForwardRef as ReactComponent };